import { CountryCode } from '~shared/constants/country-code.enum';

export const HEADER_LOGO_LINK = {
  [CountryCode.Germany]: 'https://www.metro.de/',
  [CountryCode.Spain]: 'https://www.makro.es/',
  [CountryCode.Italy]: 'https://www.metro.it/',
  [CountryCode.Portugal]: 'https://www.makro.pt/',
  [CountryCode.Netherlands]: 'https://www.makro.nl/',
  [CountryCode.France]: 'https://www.metro.fr/'
};
